import { motion } from 'framer-motion';

const FloatingSticker = ({ children, className = '', rotate = 0, delay = 0, color = '#FF3D00', textColor = '#000' }) => {
  return (
    <motion.div
      className={`absolute pointer-events-none select-none z-20 ${className}`}
      initial={{ opacity: 0, scale: 0, rotate: rotate - 30 }}
      animate={{ opacity: 1, scale: 1, rotate }}
      transition={{
        duration: 0.7,
        delay,
        type: 'spring',
        stiffness: 180,
        damping: 14,
      }}
    >
      <motion.div
        animate={{ y: [0, -6, 0] }}
        transition={{
          duration: 3 + Math.random() * 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: delay + 0.3,
        }}
        className="inline-block"
        style={{
          background: color,
          color: textColor,
          padding: '6px 14px',
          fontFamily: 'Bebas Neue, sans-serif',
          fontSize: 'clamp(11px, 1.4vw, 16px)',
          letterSpacing: '0.08em',
          border: '2px solid #000',
          boxShadow: '3px 3px 0px #000',
          whiteSpace: 'nowrap',
        }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};

export default FloatingSticker;
